module.exports = __webpack_public_path__ + "img/dna-egg-icon.50710ecc.svg";